import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {ActivatedRoute} from '@angular/router';
import {LoadingService} from '../../../shared/services/loading.service';
import {AsyncPipe} from '@angular/common';
import {LayoutService} from '../../../shared/services/layout.service';
import {HeadlineComponent} from "../../../shared/elements/headline/headline.component";
import {RouterService} from '../../../shared/services/router.service';
import {CustomerService} from '../../../shared/services/customer.service';
import {ApiService} from '../../../shared/services/api.service';
import {retry, take} from 'rxjs';
import {TokenService} from '../../../shared/services/token.service';
import {FirebaseService} from '../../../shared/services/firebase.service';
import {CustomerIconComponent} from "../../../shared/elements/customer-icon/customer-icon.component";
import {ProfileService} from '../../../shared/services/profile.service';

@Component({
    selector: 'app-sso-redirect',
    imports: [
    TranslatePipe,
    AsyncPipe,
    HeadlineComponent,
    CustomerIconComponent
],
    styleUrl: './user-migrate.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
  @if((loadingService.loadingIndicator$ | async) === 0){
  <div id="app-user-migrate" class="main-container flex-column d-flex p-2 p-md-3" role="main"
    [attr.aria-label]="('CUSTOMERMIGRATEPAGE' | translate)">
    <div class="inner-container w-100 h-100 d-flex flex-column flex-lg-row overflow-hidden custom-scrollbar">
      <!-- Left Column for Logo -->
      <div class="col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center p-3 logo">
        <app-customer-icon></app-customer-icon>
      </div>
      <!-- Right Column for Form -->
      <div class="col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center custom-scrollbar">
        <div class="scroll-wrapper w-100 p-3">
          <div class="mb-2">
            <app-headline [type]="'h4'" [title]="('CUSTOMERMIGRATIONFINISHING' | translate)"></app-headline>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
  `
})
export class UserMigrateComponent implements OnInit{
  public layoutService: LayoutService = inject(LayoutService);
  public loadingService: LoadingService = inject(LoadingService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private routerService: RouterService = inject(RouterService);
  private customerService: CustomerService = inject(CustomerService);
  private apiService: ApiService = inject(ApiService);
  private tokenService: TokenService = inject(TokenService);
  private firebaseService: FirebaseService = inject(FirebaseService);
  private profileService: ProfileService = inject(ProfileService);

  public ngOnInit(): void {
    const customerKey = this.route.snapshot.paramMap.get('customerKey') ?? undefined;
    const token = this.getLegacyToken();

    if(customerKey && token) {
      this.customerService.setCustomerKey(customerKey);
      this.apiService.getPublicCustomerResource(customerKey)
      .pipe(take(1))
      .subscribe({
      next: (customerPublicResource) => {
        this.customerService.setPublicCustomerResource(customerPublicResource);
        this.apiService.migrateLegacyToken(token)
          .pipe(
            take(1),
            retry(3)
          )
          .subscribe({
            next: (data: {token: string}) => {
              this.tokenService.setToken(data.token);
              this.profileService.loadUserProfile();
              this.firebaseService.init();
              this.routerService.navigateTo('/');
            },
            error: (error) => {
              console.error(error);
              this.routerService.navigateTo('/auth/sso');
            }
          });
        }, error: (error) => {
        console.error(error);
        this.routerService.navigateTo('/');
      }
    })
    } else {
      this.routerService.navigateTo('/');
    }
    
  }

  private getLegacyToken(): string | undefined {
    const tokenFromQueryParamMap = this.route.snapshot.queryParamMap.get('token')?.trim();
    if (tokenFromQueryParamMap) {
      return tokenFromQueryParamMap;
    }

    const tokenFromQueryParams = this.route.snapshot.queryParams?.['token'];
    if (typeof tokenFromQueryParams === 'string' && tokenFromQueryParams.trim() !== '') {
      return tokenFromQueryParams.trim();
    }

    try {
      return new URL(window.location.href).searchParams.get('token')?.trim() || undefined;
    } catch {
      return undefined;
    }
  }
}
